"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RE_YOUTUBE = /.*youtu(?:\.be|be\.com).*(?:\/|\?v=|&v=)([a-zA-Z0-9_-]+)/;
var urlToYouTubeId = function (url) {
    var match = url.match(RE_YOUTUBE);
    return match ? match[1] : null;
};
exports.default = urlToYouTubeId;
